


































import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import TableWrapper, { IControlElements } from "@/components/utility/TableWrapper.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { IActivityLog } from "@/models/activity-log.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ActivityLogModule } from "@/store/modules/activity-log.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component } from "vue-property-decorator";
import { ITableWrapperHeader } from "@/lib/types/tableWrapper";

@Component({
  components: {
    TheLayoutPortal,
    TableWrapper,
    PaginatedTable
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ActivityLogTable extends PartnerFallbackMixin {
  readonly store = ActivityLogModule;

  search = "";

  itemsPerPage = 25;

  expanded = [];
  selected: IActivityLog[] = [];

  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  headers: ITableWrapperHeader[] = [
    {
      text: this.$t("partner.ActivityLogTable.timestamp").toString(),
      align: "start",
      value: "timestamp.created",
      width: 120
    },
    {
      text: this.$t("partner.ActivityLogTable.activity").toString(),
      align: "start",
      value: "actionType",
      width: 100
    },
    {
      text: this.$t("partner.ActivityLogTable.userName").toString(),
      align: "start",
      value: "user.userName",
      width: 200
    },
    {
      text: this.$t("partner.ActivityLogTable.refType").toString(),
      align: "start",
      value: "source.refType",
      width: 200
    },
    { text: this.$t("partner.ActivityLogTable.refId").toString(), align: "start", value: "source.refId", width: 200 },
    { text: this.$t("partner.ActivityLogTable.activity").toString(), align: "start", value: "activity" },
    { text: this.$t("partner.ActivityLogTable.comment").toString(), align: "start", value: "comment", sortable: false },
    { text: "", align: "end", value: "controls", width: 200, sortable: false }
  ];

  get activityLogs(): IActivityLog[] {
    return ActivityLogModule.entities;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }

  get controlElements(): IControlElements[] {
    return [
      {
        icon: "mdi-delete-outline",
        text: this.$t("sign.DocumentTable.delete").toString(),
        action: this.delete
      }
    ];
  }

  async open(activityLog: IActivityLog) {
    // await new GoToHelper(this.$router).goToDocumentDetail(request.id, request.partnerId);
    this.$log.debug(activityLog);
  }

  async delete(activityLog: IActivityLog) {
    try {
      await activityLog.delete();
    } catch (error) {
      this.$log.error(error);
      this.$toast.error("sign.Sign.error.network");
    }
  }
}
